import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./HeroSection.module.css";

function HeroSection() {
  const [t, i18n] = useTranslation("global");
  const [services, setServices] = useState([]);
  const [headerData, setHeaderData] = useState({
    main_title: "",
    description: "",
    image: "assets/imgs/Group 1410103733.svg",
  });
  const [loadingHeader, setLoadingHeader] = useState(true);
  const [loadingServices, setLoadingServices] = useState(true);

  useEffect(() => {
    const fetchHeader = async () => {
      setLoadingHeader(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/header`,
          { headers: { "Accept-Language": i18n.language } }
        );
        const result = await response.json();
        if (result?.data?.length > 0) setHeaderData(result.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingHeader(false);
      }
    };
    fetchHeader();
  }, [i18n.language]);

  useEffect(() => {
    const fetchServices = async () => {
      setLoadingServices(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/service`,
          { headers: { "Accept-Language": i18n.language } }
        );
        const result = await response.json();
        setServices(result?.data || []);
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoadingServices(false);
      }
    };
    fetchServices();
  }, [i18n.language]);

  // Static icons for services
  const serviceIcons = [
    "assets/imgs/Branding.svg",
    "assets/imgs/Ui Design.svg",
    "assets/imgs/Product.svg",
  ];

  return (
    <header className={styles.heroSection}>
      <section className={`container ${styles.heroContainer}`}>
        <div className={`row justify-content-center ${styles.heroRow}`}>
          <div className="col-lg-6 col-12">
            <div className={styles.heroTextContainer}>
              <h1 className={`${styles.heroTitle} ${loadingHeader ? `${styles.skeleton} ${styles.titleSkeleton}` : ""}`}>
                {!loadingHeader && headerData.main_title}
              </h1>
            </div>
            <div className={styles.heroDescription}>
              <p className={loadingHeader ? `${styles.skeleton} ${styles.textSkeleton}` : ""}>
                {!loadingHeader && headerData.description}
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className={styles.heroImageContainer}>
              {loadingHeader ? (
                <div className={`${styles.skeleton} ${styles.imageSkeleton}`}></div>
              ) : (
                <img src={headerData.image} className={styles.heroImage} alt="Hero Section" />
              )}
            </div>
          </div>
        </div>

        <div className={styles.servicesSection}>
          <h3 className={styles.servicesTitle}>
            {t("hero.servicesTitle")}
          </h3>
          <div className="row align-items-center justify-content-center">
            {serviceIcons.map((iconSrc, idx) => (
              <div key={idx} className="col-lg-4 col-12 mb-4 text-center">
                <div className={styles.serviceCard}>
                  {loadingServices ? (
                    <div className={`${styles.skeleton} ${styles.imageSkeleton}`}></div>
                  ) : (
                    <div className={styles.serviceIcon}>
                      <img src={iconSrc} alt={`Service ${idx + 1}`} />
                    </div>
                  )}
                  <h4
                    className={`${styles.serviceTitle} ${
                      loadingServices ? `${styles.skeleton} ${styles.titleSkeleton}` : ""
                    }`}
                  >
                    {!loadingServices
                      ? services[idx]?.name || t(`hero.service${idx + 1}Title`)
                      : null}
                  </h4>
                  <p
                    className={`${styles.serviceDescription} ${
                      loadingServices ? `${styles.skeleton} ${styles.textSkeleton}` : ""
                    }`}
                  >
                    {!loadingServices
                      ? services[idx]?.description || t(`hero.service${idx + 1}Description`)
                      : null}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </header>
  );
}

export default HeroSection;